/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D4dInputs */

const en_mk_sol_startup_d4d = /** @type {(inputs: Mk_Sol_Startup_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important decisions are recorded once in Company memory, so next month nobody asks “why did we do it that way?”`)
};

const id_mk_sol_startup_d4d = /** @type {(inputs: Mk_Sol_Startup_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keputusan penting dicatat sekali di Memori perusahaan, jadi bulan depan tidak ada yang bertanya "kenapa dulu kita begitu?"`)
};

/**
* | output |
* | --- |
* | "Important decisions are recorded once in Company memory, so next month nobody asks “why did we do it that way?”" |
*
* @param {Mk_Sol_Startup_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d4d = /** @type {((inputs?: Mk_Sol_Startup_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d4d(inputs)
	return en_mk_sol_startup_d4d(inputs)
});